import React from 'react'

export default function FileManager() {
  return (
    <div>FileManager</div>
  )
}
